// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ZYjr","footer":"ChangeClinic_footer__2rI2Y"};